export {
  default as minus,
  ReactComponent as Minus,
} from '@assets/controls/minus.svg'    
